import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { IMG } from "../lib/assets";
import { AnimatedHeading, Reveal } from "../components/Reveal";
import { PageShell, PageHeader } from "../components/PageShell";

const ITEMS = [
  { src: IMG.brideGold, cat: "Bridal", tall: true },
  { src: IMG.spaMask, cat: "Skin & Spa" },
  { src: IMG.hairStyle, cat: "Hair" },
  { src: IMG.nailsArt, cat: "Nails" },
  { src: IMG.brideSari, cat: "Bridal", tall: true },
  { src: IMG.interiorMirror, cat: "Atelier" },
  { src: IMG.spaCream, cat: "Skin & Spa" },
  { src: IMG.hairCurl, cat: "Hair", tall: true },
  { src: IMG.brideRedGold, cat: "Bridal" },
  { src: IMG.nailsRed, cat: "Nails" },
  { src: IMG.interiorChairs, cat: "Atelier", tall: true },
  { src: IMG.brideFloral, cat: "Bridal" },
];

const FILTERS = ["All", "Bridal", "Skin & Spa", "Hair", "Nails", "Atelier"];

export default function Gallery() {
  const [filter, setFilter] = useState("All");
  const filtered =
    filter === "All" ? ITEMS : ITEMS.filter((i) => i.cat === filter);

  return (
    <PageShell>
      <PageHeader
        overline="Portfolio"
        title="A gallery of golden moments."
        subtitle="Bridal transformations, skin rituals and the quiet beauty of our atelier."
        image={IMG.brideGold}
      />

      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-wide px-6 sm:px-12">
          <div className="flex flex-wrap gap-3">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`gallery-filter-${f.toLowerCase().replace(/[^a-z]/g, "")}`}
                onClick={() => setFilter(f)}
                className={`rounded-full border px-5 py-2 text-xs uppercase tracking-[0.18em] transition-colors ${
                  filter === f
                    ? "border-gold bg-gold text-ink-900"
                    : "border-cream-50/20 text-cream-50/70 hover:border-gold/50 hover:text-gold"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <motion.div
            layout
            className="mt-12 columns-1 gap-4 sm:columns-2 lg:columns-3 [&>*]:mb-4"
          >
            <AnimatePresence>
              {filtered.map((it, i) => (
                <motion.figure
                  key={it.src}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                  className="group relative block break-inside-avoid overflow-hidden rounded-2xl"
                >
                  <img
                    src={it.src}
                    alt={it.cat}
                    loading="lazy"
                    className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                      it.tall ? "aspect-[3/4]" : "aspect-square"
                    }`}
                  />
                  <div className="absolute inset-0 flex items-end bg-gradient-to-t from-ink-900/80 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <span className="p-5 text-xs uppercase tracking-[0.2em] text-gold">
                      {it.cat}
                    </span>
                  </div>
                </motion.figure>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>
    </PageShell>
  );
}
